import { Outlet } from 'react-router-dom';

export function PlayerLayout() {
  return (
    <div className="min-h-screen bg-paper">
      <Outlet />
    </div>
  );
}
